function initializeState() {
  return {
    downloadList: []
  }
}

const state = initializeState()

const mutations = {
  SET_DOWNLOAD_LIST(state, {id, status}) {
    state.downloadList = state.downloadList.map(item => {
      if (item.id == id) {
        return { ...item, downloading: false, status: status }
      } else {
        return item
      }
    })
  },
  ADD_DOWNLOAD_LIST(state, downloadName) {
    state.downloadList = [...state.downloadList, downloadName]
  },
  REMOVE_DOWNLOAD_LIST(state) {
    state.downloadList = []
  },
  RESET_STATE(state) {
    let initial = initializeState()
    Object.assign(state, initial)
  }
}

const actions = {
  resetState({commit}) {
    commit('RESET_STATE')
  }
}

const getters = {
  getDownloadList(state) {
    return state.downloadList;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}